import styled, { css } from 'styled-components';

export const StyledBadgeWrapper = styled.div(
  ({ theme: { spacers } }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: ${spacers!.spacer02};
  `
);
